import { OportunidadProductos } from "../../../response/ventas/OportunidadResponse";

export class OportunidadSavePayload {
  id?: string;                        // omitir para crear; UUID para actualizar
  clienteId: string = "";             // requerido
  source: string = "";                // requerido
  stage?: string;                     // en creación se envía "new" (toda op nace como Lead nuevo); en update, la etapa destino
  comercialId?: string | null;
  proxContacto?: string | null;
  notas?: string;                     // si se omite en update, conserva el valor anterior
  valorCierre?: number | null;        // monto cotizado; se envía al generar la cotización
  productos?: OportunidadProductos | null;
}
